import gql from 'graphql-tag';

import { ResourceDefinition, ResourceSections } from 'src/types';

import DataPackagesShow from 'src/components/DataPackagesShow';
import CustomerDataPackagesEdit from './Edit';

export const CustomerDataPackageResource: ResourceDefinition = {
  name: 'customer_data_packages',
  section: ResourceSections.CLIENT_API,

  show: DataPackagesShow,
  edit: CustomerDataPackagesEdit,

  permissions: {
    edit: ['customerDataPackage:read'],
  },

  extension: {
    extraFields: gql`
      {
        api_fields_xrefs: api_fields {
          id
          api_field_id
          policies
          api_field {
            id
            path
          }
        }
      }
    `,
  },
};
